import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthService } from '@Services';

export const adminGuard: CanActivateFn = () => {
  const _authService = inject(AuthService);
  const _router = inject(Router);

  if (_authService.isAdmin()) {
    return _authService.isAdmin();
  } else {
    _router.navigate(['/not-found']).catch((err) => {
      console.error(err);
    });
    return false;
  }
};
